import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useLang } from "../context/LanguageContext";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";
import { safeStore } from "../lib/labText";

const inputCls = "w-full bg-transparent border border-[#262421] px-4 py-3 mt-2 outline-none focus:border-[#C49A6C] transition-colors text-[#F2EBE1] text-sm";

export default function Register() {
  const { t } = useLang();
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(form.name, form.email, form.password);
      toast.success("Account created");
      const next = safeStore.get("omr_next");
      safeStore.set("omr_next", "");
      navigate(next || "/");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Registration failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-5 py-24 md:py-32">
      <h1 className="serif text-4xl text-center mb-12">{t("register")}</h1>
      <form onSubmit={submit} className="space-y-6">
        <div>
          <label className="text-[10px] uppercase tracking-[0.2em] text-[#8A857D]">{t("name")}</label>
          <input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="register-name" className={inputCls} />
        </div>
        <div>
          <label className="text-[10px] uppercase tracking-[0.2em] text-[#8A857D]">{t("email")}</label>
          <input type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="register-email" className={inputCls} />
        </div>
        <div>
          <label className="text-[10px] uppercase tracking-[0.2em] text-[#8A857D]">{t("password_label")}</label>
          <input type="password" required minLength={6} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="register-password" className={inputCls} />
        </div>
        <button type="submit" disabled={loading} data-testid="register-submit" className="w-full bg-[#C49A6C] text-[#0B0A08] text-xs uppercase tracking-[0.25em] py-4 hover:bg-[#E7CBA9] transition-colors disabled:opacity-50">
          {loading ? "…" : t("register")}
        </button>
      </form>
      <p className="text-center text-sm text-[#8A857D] mt-8">
        {t("have_account")} <Link to="/login" className="text-[#C49A6C] link-underline">{t("login")}</Link>
      </p>
    </div>
  );
}
